module.exports = __webpack_public_path__ + "img/Bear06.d1124c8b.png";